import { Navigate, useLocation } from "react-router-dom";

/** Checkout returns to `/users`, which is the Settings users tab. */
const UsersSettingsRedirect = () => {
  const location = useLocation();
  const next = new URLSearchParams(location.search);
  next.set("tab", "users");
  return <Navigate to={`/settings?${next.toString()}`} replace />;
};

export default UsersSettingsRedirect;
